import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';
import { OrganizationState } from '../../enums/organization-state.enum';

@Component({
    selector: 'state-filter-drop-down',
    templateUrl: './state-filter-drop-down.component.html',
    styleUrls: ['./state-filter-drop-down.component.scss'],
})
export class StateFilterDropDownComponent {
    @Input() selectedStates: OrganizationState[] = [];
    @Output() stateChange = new EventEmitter<OrganizationState[]>();

    openedFlyout = false;
    @Input() rightAlignment: boolean = false;
    flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    statusOptions = Object.values(OrganizationState).map((state) => ({ label: state, value: state }));
    @Input() singleSelection = false;

    isFilterActive: boolean = this.selectedStates.length > 0;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedStates']) {
            this.isFilterActive = this.selectedStates && this.selectedStates.length > 0;
        }
    }

    toggleStateSelection(value: OrganizationState): void {
        if (this.singleSelection) {
            this.selectedStates = [value];
            this.applyFilter();
            return;
        }

        const isCurrentlySelected = this.selectedStates.includes(value);
        this.onStateSelection(value, !isCurrentlySelected);
    }

    onStateSelection(value: OrganizationState, checked: boolean) {
        if (this.singleSelection) {
            this.selectedStates = [];
            this.selectedStates.push(value);
            this.applyFilter();
            return;
        }

        if (checked) {
            this.selectedStates.push(value);
        } else {
            this.selectedStates = this.selectedStates.filter((v) => v !== value);
        }
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;

        if (!buttonElement) return;

        const rect = buttonElement.getBoundingClientRect();

        this.flyoutPosition = {
            top: rect.bottom + 8,
            right: rect.right,
            left: rect.left,
        };

        const diffrence = rect.left - rect.right;

        if (this.rightAlignment) {
            this.flyoutPosition.left += diffrence;
        }

        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    applyFilter(): void {
        this.isFilterActive = this.selectedStates.length > 0;
        this.closeFlyout();
        this.stateChange.emit(this.selectedStates);
    }

    clearFilter(): void {
        this.selectedStates = [];
        this.isFilterActive = false;
        this.closeFlyout();
        this.stateChange.emit(this.selectedStates);
    }
}
